export default function getUrls(guid?: string) {
    return {
        ...(guid
            ? {
                  edit: `/magazine-issue/edit/${guid}`,
                  addArticle: `/magazine-issue/view/${guid}/add-article`,
              }
            : {}),
    }
}
